const DOTS = "...";
const DOTS_LEN = 3;

export function truncate(str: string, truncate_to: number): string {
  if (str.length <= truncate_to) {
    return str;
  }
  return `${str.substring(0, truncate_to - DOTS_LEN)}${DOTS}`;
}

export function truncateCenter(str: string, truncate_to: number): string {
  if (str.length <= truncate_to) {
    return str;
  }

  const len = truncate_to - DOTS_LEN;
  const head = Math.floor(len / 2);
  const tail = len - head;
  return `${str.substring(0, head)}${DOTS}${str.substring(str.length - tail)}`;
}
